import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { noop } from 'lodash';
import { forwardRef } from 'react';
import { Container } from '../../primitives/Pagination/components/Container.js';
import { usePagination } from '../../primitives/Pagination/hooks/usePagination.js';
import { Item } from '../../primitives/Pagination/Item/index.js';
export const Pagination = /*#__PURE__*/_styled(forwardRef(({
  page,
  pageCount,
  boundaryCount,
  siblingCount,
  variant,
  size,
  label = {},
  showFirstButton = false,
  showLastButton = false,
  onChange = noop,
  renderItem = props => _jsx(Item, {
    ...props
  }, `${props.type}_${props.page}_${props.label}_${props.selected}`),
  ...restProps
}, ref) => {
  const items = usePagination({
    page,
    pageCount,
    boundaryCount,
    siblingCount
  });
  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: (string | number | boolean | Rea... Remove this comment to see the full error message
    _jsx(Container, {
      ...restProps,
      ref: ref,
      children: items.filter(({
        type
      }) => (type !== 'first' || showFirstButton) && (type !== 'last' || showLastButton)).map(props => renderItem({
        ...props,
        variant,
        size,
        label: label[props.type],
        onClick: !props.disabled ? event => onChange(event, props.page) : undefined
      }))
    })
  );
}), process.env.NODE_ENV === "production" ? {
  target: "eh77vho0"
} : {
  target: "eh77vho0",
  label: "Pagination"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");